import {
  LOGIN_WITH_OAUTH_LOADING,
  LOGIN_WITH_OAUTH_SUCCESS,
  LOGIN_WITH_OAUTH_FAIL,
  LOGIN_LOCAL_LOADING,
  LOGIN_LOCAL_SUCCESS,
  LOGIN_LOCAL_FAIL,
  SIGNUP_LOCAL_LOADING,
  SIGNUP_LOCAL_SUCCESS,
  SIGNUP_LOCAL_FAIL,
  LOGOUT_SUCCESS,
  ME_FAIL,
  ME_LOADING,
  ME_SUCCESS,
  CLEAR_AUTH_ERROR,
} from "./types";

export const authReducer = (state, { type, payload }) => {
  switch (type) {
    case LOGIN_WITH_OAUTH_LOADING:
    case LOGIN_LOCAL_LOADING:
    case SIGNUP_LOCAL_LOADING:
    case ME_LOADING:
      return { ...state, isLoading: true, error: null, appLoaded: false };

    case LOGIN_WITH_OAUTH_SUCCESS:
    case LOGIN_LOCAL_SUCCESS:
    case SIGNUP_LOCAL_SUCCESS:
      localStorage.setItem("token", JSON.stringify(payload.token));
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        token: payload.token,
        appLoaded: true,
        me: payload.me,
        error: null,
      };

    case LOGIN_WITH_OAUTH_FAIL:
    case LOGIN_LOCAL_FAIL:
    case SIGNUP_LOCAL_FAIL:
      return {
        ...state,
        me: null,
        isAuthenticated: false,
        isLoading: false,
        appLoaded: true,
        error: payload.error,
      };

    case ME_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        appLoaded: true,
        me: payload.me,
        error: null,
      };

    case ME_FAIL:
      localStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        appLoaded: true,
        me: null,
        error: null,
      };

    case LOGOUT_SUCCESS:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        me: null,
        isAuthenticated: false,
        isLoading: false,
        appLoaded: true,
        error: null,
      };

    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
